export default "__VITE_ASSET__DirDIRZG__"